
import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
// local
import { RouteGuardService } from './route-guard.service';
import { LoginComponent } from '../login/login.component';
import { LogoutComponent } from '../logout/logout.component';
import { NotFoundComponent } from './not-found.component';
import { RouteData } from 'src/app/models';
import { ConcurrentComponent } from '../concurrent/concurrent.component';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';

const ROLEDATA_PUBLIC = { HuronAdministrator: true, CorporationAdministrator: true, CoachImpersonate: true, User: true, None: true };
const ROLEDATA_AUTHENTICATED = { HuronAdministrator: true, CorporationAdministrator: true, CoachImpersonate: true, User: true };

const routes: Routes = [
	{
		path: 'admin',
		canActivate: [RouteGuardService],
		data: new RouteData({ 
            routeId: 'ADMIN', 
            roles: { HuronAdministrator: true, CorporationAdministrator: true, CoachImpersonate: true, UserAdministrator: true, ClientAdministrator:true } 
        }),
		loadChildren: () => import('modules/admin/admin.module').then(m => m.AdminModule)
	},
	{
		path: 'studer',
		canActivate: [RouteGuardService],
		data: new RouteData({ 
            routeId: 'STUDER', 
            roles: { HuronAdministrator: true, CorporationAdministrator: true, CoachImpersonate: true } 
        }),
		loadChildren: () => import('modules/studer/studer.module').then(m => m.StuderModule)
	},
	{
		path: 'home',
		canActivate: [RouteGuardService],    
        data: new RouteData({ 
            routeId: 'HOME', 
            roles: ROLEDATA_AUTHENTICATED
        }), 
		loadChildren: () => import('modules/landing/landing.module').then(m => m.LandingModule)
	},
	{
		path: 'notifications',
		canActivate: [RouteGuardService],    
        data: new RouteData({ 
            routeId: 'NOTIFICATIONS', 
            roles: ROLEDATA_AUTHENTICATED
        }), 
		loadChildren: () => import('modules/notifications/notifications.module').then(m => m.NotificationsModule),
	},
	{
		path: 'login',
        data: new RouteData({ 
            routeId: 'LOGIN', 
            roles: ROLEDATA_PUBLIC 
        }),
		component: LoginComponent,
	},
	{
        // Mobile login routing has changed to use normal login routing.
        // This is because the 90 token is no longer supported and we want
        // to force users to use the same authentication flow as browser.
		path: 'mobile-login',
        data: new RouteData({ 
            routeId: 'LOGIN', 
            roles: ROLEDATA_PUBLIC 
        }),
		component: LoginComponent,
	},
	{
		path: 'logout',
		component: LogoutComponent,
	},
	{
		path: 'inactive',
		canActivate: [RouteGuardService],
        data: new RouteData({ 
            routeId: 'INACTIVE', 
            roles: ROLEDATA_AUTHENTICATED
        }), 
		component: LogoutComponent,
	},
	{
		path: 'concurrent',
        data: new RouteData({ 
            routeId: 'CONCURRENT', 
            roles: ROLEDATA_PUBLIC
        }),
		component: ConcurrentComponent,
	},
	{
		path: 'profile',
		canActivate: [RouteGuardService],
        data: new RouteData({ 
            routeId: 'PROFILE', 
            roles: ROLEDATA_AUTHENTICATED
        }),
        loadChildren: () => import('modules/profile/profile.module').then(m => m.ProfileModule)
	},
	{
		path: 'landing',
		redirectTo: '/home',
	},
	{
		path: 'contact',
        data: new RouteData({ 
            routeId: 'CONTACT', 
            roles: ROLEDATA_PUBLIC
        }),
        loadChildren: () => import('modules/contact/contact.module').then(m => m.ContactModule)
	},
	{
		path: 'unauthorized',
        data: new RouteData({ 
            routeId: 'UNAUTHORIZED', 
            roles: ROLEDATA_PUBLIC 
        }),
		component: UnauthorizedComponent,
	},
	{	// All auxiliary routes (redirects, etc) should belong under an "aux" route. E.G: 'aux/verify/sms', 'aux/verify/sms', etc
		path: 'aux/auth/token/callback',
        data: new RouteData({ 
            routeId: 'AUXILIARY:AUTHENTICATION:TOKEN-CALLBACK', 
            roles: ROLEDATA_PUBLIC
        }),
		children: []
	},
    {
		path: '',
        data: new RouteData({ 
            routeId: 'ROOT', 
            roles: ROLEDATA_PUBLIC 
        }),
		redirectTo: '/home',  
		pathMatch: 'full',
	},
	{
		path: '**',
        data: new RouteData({ 
            routeId: '404', 
            roles: ROLEDATA_PUBLIC 
        }),
		component: NotFoundComponent,
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			// useHash: true,
			preloadingStrategy: NoPreloading
			// for debugging
			// , enableTracing: true
		}),
		// LandingModule,
	],
	providers: [RouteGuardService],
	declarations: [ ],
	exports: [RouterModule],
})
export class AppRoutingModule { }
